import React from 'react';
import styled from 'styled-components';
import { border1, red } from 'utils/style/colors';
import messages from './Messages';
import { IOption } from 'components/Select/Select';
import Modal from 'components/Modal';
import Select from 'components/Select';
import Icon from 'components/Icon';
import { IUser, IUsers } from 'store/users/usersType';
import { ITemplateAdmin } from 'store/templates/templatesSlice';

interface ITemplateAdminModalProps {
  searchUser: (phoneNumber: string) => any;
  admins: Array<ITemplateAdmin>;
  isActive: boolean;
  onClose: () => void;
  onChangeAdmin: (type: string, adminId: number) => void;
  users: IUsers;
}

interface ITemplateAdminModalState {
  searchTerm: string;
  searchResult: IOption[];
  selectedUsers: IOption[];
}

const AdminList = styled('div')`
  margin: 1rem 0;
  border: ${border1};
  border-radius: 10px;
`;

const AdminItem = styled('div')`
  padding: 0.5rem 1rem;
  border-bottom: 1px solid var(--gray);
  &:last-child {
    border: none;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > i {
    cursor: pointer;
    color: gray;
  }
  & > i:hover {
    color: ${red};
  }
`;

class TemplateAdminModal extends React.PureComponent<
  ITemplateAdminModalProps,
  ITemplateAdminModalState
> {
  constructor(props: ITemplateAdminModalProps) {
    super(props);
    this.state = {
      searchTerm: '',
      searchResult: [],
      selectedUsers: [],
    };
  }

  handleSearch = (searchTerm: string) => {
    this.props.searchUser(searchTerm).then((result: any[]) => {
      const items: IOption[] = result.reduce((list, user: IUser) => {
        const item: IOption = {
          value: user.id,
          label: user.name,
        };
        list.push(item);
        return list;
      }, []);
      this.setState({ searchResult: items });
    });
  };

  onSelectUser = (values: IOption[]) => {
    const admin: IOption = values[0];
    this.props.onChangeAdmin('add', admin.value as number);
    this.setState({ searchResult: [] });
  };

  handleRemoveAdmin = (adminId: number) => () => {
    const isConfirmed = window.confirm(messages.areYouSureToRemoveThisUser);
    if (isConfirmed) {
      this.props.onChangeAdmin('remove', adminId);
    }
  };
  // TODO: define Types
  render() {
    const { admins, onClose, isActive, users } = this.props;
    return (
      <Modal
        title={messages.templateAdmins}
        onClose={onClose}
        isActive={isActive}
      >
        <Select
          values={[]}
          options={this.state.searchResult}
          onChangeValues={this.onSelectUser}
          onSearch={this.handleSearch}
          placeholder={messages.searchUserByMobile}
        />
        {admins.length > 0 && (
          <AdminList>
            {admins.map((admin?: ITemplateAdmin) => (
              <AdminItem key={admin!.userId}>
                <span>{users.map[admin!.userId!].name}</span>
                <Icon
                  type={'trash-2'}
                  onClick={this.handleRemoveAdmin(admin!.userId)}
                />
              </AdminItem>
            ))}
          </AdminList>
        )}
      </Modal>
    );
  }
}
export default TemplateAdminModal;
